<template>
  <div class="unit-list">
    <transition-group class="column" name="slide-up" tag="ul" appear>
      <UnitCardCleaner
        v-for="unit in unit.units"
        :key="unit.id"
        :unit="unit"
      />
    </transition-group>
  </div>
</template>

<script>
import UnitCardCleaner from '@/components/ui/UnitCardCleaner.vue'
import { mapState } from 'vuex'

export default {
	metaInfo() {
    return {
      title: this.$i18n.tc('unit', 2),
    }
  },
  components: {
    UnitCardCleaner
  },
  created() {
    this.$store.dispatch('unit/fetchUnits')
  },
  computed: mapState(['unit', 'client'])
}
</script>

<style  lang="scss" scoped>
.unit-list {
  margin-top: 70px;
}

.column {
    display: flex;
    flex-flow: wrap;
    height: 100%;
	justify-content: center;
	padding: 0;
  }

@media screen and (max-width: 500px) {
	.unit-list {
  margin-top: 10px;
}
}

</style>
